import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ArrowRight",
  "use": "icon-ArrowRight-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-ArrowRight\"><path d=\"M17.643 11.257l-4.707-4.701L13.993 5.5 20.5 12l-6.507 6.5-1.057-1.056 4.7-4.694L3.5 12.746v-1.492l14.143.003z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol